var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.locationLoading
    ? _c(
        "div",
        {
          ref: "affiliateResizeRoot",
          staticClass: "text-center loading-container-affiliate-widget",
          staticStyle: { padding: "50px" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("loading_cost_info")))])
        ]
      )
    : _vm.location && _vm.location.name
    ? _c(
        "div",
        { ref: "affiliateResizeRoot", staticClass: "affiliate-widget-card" },
        [
          _c(
            "div",
            {
              staticClass: "general-info-container",
              class: {
                "general-info-container--added": _vm.reservationData.added
              }
            },
            [
              _c("div", { staticClass: "col-1" }, [
                _c("div", { staticClass: "location-info-container" }, [
                  _c("div", { staticClass: "location-photo-container" }, [
                    _c("img", {
                      staticClass: "location-featured-photo",
                      attrs: { src: _vm.coverPhoto && _vm.coverPhoto.image_url }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "location-photo-label" },
                      [
                        _c("parkingIcon", {
                          attrs: { width: "30", height: "35" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("airport_parking")))])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "logo-label" },
                      [
                        _c("starRatingIcon"),
                        _vm._v(" "),
                        _c("div", { staticClass: "rating-number" }, [
                          _vm._v(
                            _vm._s(parseFloat(_vm.location.rating).toFixed(1)) +
                              "/5"
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c(
                      "div",
                      { staticClass: "location-name-container-wrapper" },
                      [
                        _c("div", { staticClass: "location-name-container" }, [
                          _c("div", { staticClass: "location-name-content" }, [
                            _c("div", { staticClass: "location-name" }, [
                              _vm._v(
                                _vm._s(_vm.$t("add_parking_at")) +
                                  " " +
                                  _vm._s(
                                    _vm.location.port && _vm.location.port.code
                                      ? _vm.location.port.code +
                                          " " +
                                          _vm.$t("airport")
                                      : ""
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "location-name subtitle" },
                              [_vm._v(_vm._s(_vm.location.name))]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "location-info-content" }, [
                      _c("div", { staticClass: "location-info" }, [
                        _c(
                          "div",
                          { staticClass: "port-location--distance" },
                          [
                            _c("locationPinIcon"),
                            _vm._v(" "),
                            _c("div", { staticClass: "distance" }, [
                              _vm._v(
                                _vm._s(_vm.location.distance_from_airport) +
                                  " " +
                                  _vm._s(_vm.location.distance_unit) +
                                  _vm._s(
                                    _vm.location.distance_unit == "km"
                                      ? "s"
                                      : ""
                                  ) +
                                  " " +
                                  _vm._s(
                                    " from " +
                                      (_vm.location.port &&
                                        _vm.location.port.name)
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.location.shuttle_service
                          ? _c("div", { staticClass: "free-shuttle" }, [
                              _c(
                                "div",
                                { staticClass: "shuttle-info-title-container" },
                                [
                                  _c("shuttleBusIcon"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "shuttle-info-title" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "shuttle-info-title-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("shuttle_included"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "shuttle-info",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.extractContent(
                                      _vm.location.shuttle_summary,
                                      true
                                    )
                                  )
                                }
                              })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "reservation-notes" }, [
                        _vm.parkingCancellationPolicies &&
                        _vm.parkingCancellationPolicies
                          .fullyRefundableUntillStart
                          ? _c(
                              "div",
                              { staticClass: "reservation-note-item d-flex" },
                              [
                                _c("checkIcon"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("cancel_free_until_start_time")
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.location.shuttle_service
                          ? _c(
                              "div",
                              { staticClass: "reservation-note-item d-flex" },
                              [
                                _c("checkIcon"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("shuttle_to_terminal_included")
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.addTripProtection &&
                        _vm.protectionPlan &&
                        _vm.protectionPlan.coverage_value != null
                          ? _c(
                              "div",
                              { staticClass: "reservation-note-item" },
                              [
                                _c("checkIcon"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("vehicle_protection_up_to")
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.protectionPlan.coverage_value,
                                          _vm.currencySymbol(
                                            _vm.location.currency.code
                                          ),
                                          0
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "port-location--rating" },
                        [
                          _vm._l(_vm.amenities, function(item) {
                            return _c(
                              "div",
                              {
                                key: item.amenity_id,
                                staticClass: "parking-detail-item"
                              },
                              [
                                _c("img", {
                                  staticClass: "logo",
                                  attrs: {
                                    src: item.icon_url,
                                    alt: item.display_name
                                  }
                                })
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "see-parking-details",
                              attrs: { type: "button" },
                              on: { click: _vm.toggleParkingDetails }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("see_parking_details")))
                              ]),
                              _vm._v(" "),
                              !_vm.showParkingDetails
                                ? _c("chevronDownIcon")
                                : _c("chevronUpIcon")
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-2",
                  class: { "col-2--added": _vm.reservationData.added }
                },
                [
                  _c("div", { staticClass: "parking-details-container" }, [
                    _c("div", { staticClass: "parking-price-container" }, [
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.totalPrice,
                              _vm.currencySymbol(_vm.location.currency.code),
                              2
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "price-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("total_for") +
                              " " +
                              _vm.numberOfDays +
                              " " +
                              _vm.$t("day") +
                              (_vm.numberOfDays > 1 ? "s" : "")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "includes-taxes-and-fees" }, [
                        _vm._v(_vm._s(_vm.$t("includes_taxes_and_fees")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.formLevelError
                    ? _c("div", { staticClass: "error-message" }, [
                        _c("div", { staticClass: "error-icon" }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.formLevelError))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showParkingDetails
                    ? _c(
                        "div",
                        { staticClass: "reservation-info" },
                        [
                          _vm.reservationData.added
                            ? _c("addedButton", {
                                staticClass: "added-parking-btn",
                                attrs: { label: _vm.$t("added") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.reservationData.added
                            ? _c(
                                "button",
                                {
                                  staticClass: "add-parking-btn",
                                  attrs: { disabled: _vm.isActionDisabled },
                                  on: { click: _vm.toggleParkingDetails }
                                },
                                [
                                  _c("plusIcon"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("add_parking")))
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.showParkingDetails
            ? _c("div", [
                _c("div", { staticClass: "more-info-container" }, [
                  _c(
                    "div",
                    {
                      ref: "requiredInformation",
                      staticClass: "extra-fields-container show"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "additional-info" },
                        [
                          !_vm._.isEmpty(_vm.location.extra_fields) ||
                          _vm.location.car_iframe
                            ? _c(
                                "div",
                                { staticClass: "extra-fields--header" },
                                [_vm._v(_vm._s(_vm.$t("additional_info")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.location.car_iframe
                            ? _c("carVariables", {
                                attrs: {
                                  locationId: Number(_vm.location.reslab_id)
                                },
                                on: { carsDataChanged: _vm.carsDataChanged }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.location.car_iframe && _vm.carsDataError
                            ? _c("div", { staticClass: "error-message" }, [
                                _c("div", { staticClass: "error-icon" }),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(_vm.carsDataError))])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm._.isEmpty(_vm.location.extra_fields)
                            ? _c(
                                "div",
                                { staticClass: "extra-fields-container--body" },
                                _vm._l(_vm.location.extra_fields, function(
                                  field
                                ) {
                                  return _c(
                                    "div",
                                    { key: field.name },
                                    _vm._l(
                                      _vm.form.extra_fields[field.name],
                                      function(val, i) {
                                        return _vm.form.extra_fields &&
                                          _vm.form.extra_fields[field.name]
                                          ? _c("div", { key: i }, [
                                              !field.per_car ||
                                              _vm.form.number_of_spots == 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "field-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(field.label) +
                                                          "\n                                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              field.per_car &&
                                              _vm.form.number_of_spots > 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "field-title"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "Car number " +
                                                              (i + 1)
                                                          ) + " - "
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(field.label) +
                                                          "\n                                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              field.input_type ==
                                              "license_plate"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.extra_fields[
                                                            field.name
                                                          ][i],
                                                        expression:
                                                          "form.extra_fields[field.name][i]"
                                                      }
                                                    ],
                                                    staticClass: "extras-field",
                                                    class: {
                                                      disabled:
                                                        _vm.isActionDisabled
                                                    },
                                                    style: {
                                                      border: _vm.fieldErrorText(
                                                        field.name,
                                                        i
                                                      )
                                                        ? _vm.isPlateWarning(
                                                            _vm.fieldErrorText(
                                                              field.name,
                                                              i
                                                            )
                                                          )
                                                          ? "1px solid #FF8C00 !important"
                                                          : "1px solid #D72C0D !important"
                                                        : ""
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        "Enter" +
                                                        " " +
                                                        field.label,
                                                      autocomplete:
                                                        "do-not-autofill"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.extra_fields[
                                                          field.name
                                                        ][i]
                                                    },
                                                    on: {
                                                      input: [
                                                        function($event) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .extra_fields[
                                                              field.name
                                                            ],
                                                            i,
                                                            $event.target.value
                                                          )
                                                        },
                                                        function($event) {
                                                          return _vm.onExtraFieldInput(
                                                            field.name,
                                                            i
                                                          )
                                                        }
                                                      ]
                                                    }
                                                  })
                                                : _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.extra_fields[
                                                            field.name
                                                          ][i],
                                                        expression:
                                                          "form.extra_fields[field.name][i]"
                                                      }
                                                    ],
                                                    staticClass: "extras-field",
                                                    class: {
                                                      disabled:
                                                        _vm.isActionDisabled,
                                                      "error-field":
                                                        !!_vm.fieldErrorText(
                                                          field.name,
                                                          i
                                                        ) &&
                                                        !_vm.isPlateWarning(
                                                          _vm.fieldErrorText(
                                                            field.name,
                                                            i
                                                          )
                                                        )
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Enter" +
                                                        " " +
                                                        field.label
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.extra_fields[
                                                          field.name
                                                        ][i]
                                                    },
                                                    on: {
                                                      input: [
                                                        function($event) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .extra_fields[
                                                              field.name
                                                            ],
                                                            i,
                                                            $event.target.value
                                                          )
                                                        },
                                                        function($event) {
                                                          return _vm.onExtraFieldInput(
                                                            field.name,
                                                            i
                                                          )
                                                        }
                                                      ]
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _vm.fieldErrorText(
                                                field.name,
                                                i
                                              ) &&
                                              !_vm.isPlateWarning(
                                                _vm.fieldErrorText(
                                                  field.name,
                                                  i
                                                )
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "error-message"
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "error-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.fieldErrorText(
                                                              field.name,
                                                              i
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm.isPlateWarning(
                                                    _vm.fieldErrorText(
                                                      field.name,
                                                      i
                                                    )
                                                  )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "warning-message"
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "warning-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.fieldErrorText(
                                                                field.name,
                                                                i
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.costs &&
                      _vm.costs.warning &&
                      (_vm.costs.warning.includes(
                        "falls outside of shuttle hours"
                      ) ||
                        _vm.costs.warning.includes(
                          "location charges minimum of"
                        ) ||
                        _vm.costs.warning.includes(
                          "emplacement exige un minimum de"
                        ))
                        ? _c("div", { staticClass: "separator-mobile" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-side",
                          class: {
                            "display-mobile-none": !(
                              _vm.costs &&
                              _vm.costs.warning &&
                              (_vm.costs.warning.includes(
                                "falls outside of shuttle hours"
                              ) ||
                                _vm.costs.warning.includes(
                                  "location charges minimum of"
                                ) ||
                                _vm.costs.warning.includes(
                                  "emplacement exige un minimum de"
                                ))
                            )
                          }
                        },
                        [
                          _vm.costs &&
                          _vm.costs.warning &&
                          (_vm.costs.warning.includes(
                            "location charges minimum of"
                          ) ||
                            _vm.costs.warning.includes(
                              "emplacement exige un minimum de"
                            ))
                            ? _c(
                                "div",
                                { staticClass: "warning-message" },
                                [
                                  _c("infoWarningIcon"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("minimum_of_days_booking", {
                                            number:
                                              _vm.location.min_booking_days
                                          })
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.costs &&
                          _vm.costs.warning &&
                          _vm.costs.warning.includes(
                            "falls outside of shuttle hours"
                          )
                            ? _c(
                                "div",
                                { staticClass: "warning-message" },
                                [
                                  _c("infoWarningIcon"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "booking_falls_outside_shuttle_hours"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.reservationData.added
                            ? _c(
                                "button",
                                {
                                  staticClass: "add-parking-btn step-2",
                                  attrs: { disabled: _vm.isConfirmDisabled },
                                  on: { click: _vm.handleConfirm }
                                },
                                [
                                  _c("plusIcon", {
                                    attrs: {
                                      color: _vm.isConfirmDisabled
                                        ? "#686868"
                                        : "#FFF"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.confirmInProgress
                                    ? _c("div", {
                                        staticClass:
                                          "spinner-border spinner-border-sm",
                                        attrs: { role: "status" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("add_for")) +
                                        " " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.totalPrice,
                                            _vm.currencySymbol(
                                              _vm.location.currency.code
                                            ),
                                            2
                                          )
                                        )
                                    )
                                  ])
                                ],
                                1
                              )
                            : _c("addedButton", {
                                staticClass: "added-parking-btn desktop",
                                attrs: {
                                  label:
                                    _vm.$t("added_for") +
                                    " " +
                                    _vm.manageInfoPriceDisplay
                                }
                              })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separator" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "special-condition show" }, [
                    _c("div", { staticClass: "content" }, [
                      _vm.location.shuttle_summary
                        ? _c("div", { staticClass: "shuttle-info" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _c("shuttleBusIcon", {
                                  attrs: { fill: "#333333" }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("shuttle_info")))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "shuttle-summary",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.extractContent(
                                    _vm.location.shuttle_summary
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "warnings" },
                              _vm._l(_vm.location.warnings, function(
                                warning,
                                i
                              ) {
                                return _c(
                                  "div",
                                  { staticClass: "location-warning" },
                                  [
                                    _c("img", {
                                      staticClass: "mr-1",
                                      attrs: {
                                        src: "/assets/warning.svg",
                                        alt: "warning",
                                        width: "14",
                                        height: "15"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "location-warning-text" },
                                      [_vm._v(_vm._s(warning))]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.location.shuttle_summary
                        ? _c("div", { staticClass: "separator" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "details" },
                        [
                          _c(
                            "div",
                            { staticClass: "title" },
                            [
                              _c("specialConditionsDocIcon"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("special_conditions")))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("location-info-table", {
                            attrs: {
                              location: _vm.location,
                              parkingCancellationPolicies:
                                _vm.parkingCancellationPolicies
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-section-mobile" },
            [
              _c("div", { staticClass: "parking-price-container" }, [
                _c("span", { staticClass: "amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.totalPrice,
                        _vm.currencySymbol(_vm.location.currency.code),
                        2
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "price-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("total_for") +
                        " " +
                        _vm.numberOfDays +
                        " " +
                        _vm.$t("day") +
                        (_vm.numberOfDays > 1 ? "s" : "")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "includes-taxes-and-fees" }, [
                  _vm._v(_vm._s(_vm.$t("includes_taxes_and_fees")))
                ])
              ]),
              _vm._v(" "),
              _vm.reservationData.added
                ? _c("addedButton", {
                    staticClass: "added-parking-btn mobile",
                    attrs: { label: _vm.$t("added") }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.reservationData.added && !_vm.showParkingDetails
                ? _c(
                    "button",
                    {
                      staticClass: "add-parking-btn",
                      attrs: { disabled: _vm.isActionDisabled },
                      on: { click: _vm.toggleParkingDetails }
                    },
                    [
                      _c("plusIcon"),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("add_parking")))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.reservationData.added && _vm.showParkingDetails
                ? _c(
                    "button",
                    {
                      staticClass: "add-parking-btn step-2",
                      attrs: { disabled: _vm.isConfirmDisabled },
                      on: { click: _vm.handleConfirm }
                    },
                    [
                      _c("plusIcon", {
                        attrs: {
                          color: _vm.isConfirmDisabled ? "#686868" : "#FFF"
                        }
                      }),
                      _vm._v(" "),
                      _vm.confirmInProgress
                        ? _c("div", {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("add_parking")))])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _c("div", { ref: "affiliateResizeRoot" }, [
        _vm._v("\n    " + _vm._s(_vm.errors) + "\n")
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fffb960", { render: render, staticRenderFns: staticRenderFns })
  }
}